import { useAuth0 } from '@auth0/auth0-react';
import EmployeeCardOrion from '@ben/orion/left-navigation/employee-card';

const EmployeeCard = () => {
  const { user, logout } = useAuth0();

  const logoutUrl =
    process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT === 'development'
      ? window.location.origin
      : `${window.location.origin}/modben/`;

  const onSignOut = () => {
    void logout({
      logoutParams: { returnTo: logoutUrl },
    });
  };

  return (
    <EmployeeCardOrion
      employee={{
        avatar: user?.picture,
        firstName: user?.given_name,
        lastName: user?.family_name,
        email: user?.email,
      }}
      onSignOut={onSignOut}
      helpMenuProps={{ hasIntercom: false }}
    />
  );
};

export default EmployeeCard;
